import React, { useMemo } from 'react';
import SegmentedPolylineOverlay from './SegmentedPolylineOverlay';

const speedColors = [
  '#d32f2f', // red
  '#f57c00', // orange
  '#fbc02d', // yellow
  '#1976d2', // blue
  '#388e3c', // green
];

const speedRanges = [
  { min: 0, max: 1.5, color: speedColors[0] },
  { min: 1.5, max: 3, color: speedColors[1] },
  { min: 3, max: 4.5, color: speedColors[2] },
  { min: 4.5, max: 6, color: speedColors[3] },
  { min: 6, max: Infinity, color: speedColors[4] },
];

const legendFormatter = r =>
  r.max === Infinity
    ? `${r.min}+`
    : `${r.min} - ${r.max}`;

export default function GpsSpeedOverlay({ routes }) {
  // routes: array of segments (arrays of points)
  const allPoints = useMemo(() => routes.flat(), [routes]);

  // Only render overlay if there are points
  if (!allPoints.length) return null;

  return (
    <SegmentedPolylineOverlay
      segments={routes}
      valueSelector={pt => pt.speedMph >= 0 ? pt.speedMph : 0}
      ranges={speedRanges}
      legendTitle="Speed Legend (mph)"
      legendFormatter={legendFormatter}
      units="mph"
      discrete={false}
    />
  );
}